var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-tooltip-btn',{attrs:{"href":"https://store.vuetifyjs.com/","icon":"$mdiCartOutline","path":"store","rel":"noopener","target":"_blank"}})}
var staticRenderFns = []

export { render, staticRenderFns }